'use strict';

module.exports = require('./lib/errors.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/request-promise-core/errors.js
// module id = 1393
// module chunks = 0